<template>
  <div class="order-wrapper payment-wrapper" :class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <primary-filter
        :searchParameters="firstInAllotmentSearchParameters"
        :menuOptions="$checkMenuOptions(firstInAllotmentMenu)"
        :selectedCategory="selectedCategory"
        :preSearchedParams="searchedParams"
        :enableSearchPopup="true"
        @searchByParameter="searchByParameter" />
    </portal>
    <div>
      <div class="flex-container page-filter">
        <div class="flex-item">
          <filter-wrapper
            :values="filterTags"
            @openSliderLeft="openSlideleft = !openSlideleft"/>
        </div>
      </div>
      <div class="slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
        <div class="slideleft_content">
          <div class="content">
            <div
              v-infinite-scroll="loadData"
              infinite-scroll-disabled="loadCheck"
              infinite-scroll-throttle-delay="400"
              infinite-scroll-distance="10">
              <FirstInAllotmentHeader
                :headers="firstInAllotmentHeader"
                :hideSelectAll="true"
                :noCheckbox="true"
                 />
              <div v-if="isLoading" class="paymentloader"></div>
              <div v-else-if="firstInTransporterList.length === 0" class="emptydiv">
                <div class="paymentempty"></div>
                <div class="emptytext">{{$t('INDENTS_NO_INDENTS_FOUND')}}</div>
              </div>
              <div v-else>
                <FirstInAllotmentRow v-for="(order,index) in firstInTransporterList"
                  :key="index"
                  :sectionHeader="firstInAllotmentHeader"
                  :order="order"
                  :isFilterClosed="!openSlideleft"
                  @showActions="showActions(order.order_no)" />
                <div v-if="isPaginating">
                  <Spinner />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slideleft_menu">
          <sec-filter
            v-if="filterConstant.length"
            :selectedFilters="filterConstant"
            @search="search"
            @updateOption="updateOption"
            @reset="resetApply"
            @clearDate="clearDate" />
        </div>
        <div>
          <drawer
            direction="rtl"
            size="740px"
            class="default-drawer"
            :visible.sync="isDetailsEnabled"
            :modal="true"
            :withHeader="false"
            :append-to-body="true">
            <Link :underline="false" class="nav-close" @click="isDetailsEnabled=false">
              <svgicon name="cancelwhite" width="12" height="12" :original="true" />
            </Link>
            <FirstInTransporterActions
              v-if="isDetailsEnabled"
              :order="selectedOrder"
              @accept="accept" />
          </Drawer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  firstInAllotmentMenu,
  filters, firstInAllotmentSearchParameters,
  firstInAllotmentHeader, indentMovementTypes } from '@/constants/indentConstants';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import FilterWrapper from '@common/components/FilterWrapperV2';
import FirstInAllotmentHeader from '@common/components/HeaderV2';
import PrimaryFilter from '@/modules/common/PrimaryFilter';
import FirstInAllotmentRow from '@/modules/indents/components/firstInAllotmentRow';
import FirstInTransporterActions from '@/modules/indents/components/details/firstInTransporterActions';

export default {
  components: {
    FirstInAllotmentHeader,
    SecFilter,
    FilterWrapper,
    PrimaryFilter,
    FirstInAllotmentRow,
    FirstInTransporterActions,
  },
  data() {
    return {
      firstInAllotmentMenu,
      filters,
      firstInAllotmentHeader,
      openSlideleft: false,
      defaultValues: {},
      filterConstant: [],
      loadCheck: true,
      isDetailsEnabled: false,
      selectedOrder: null,
      indentMovementTypes,
      firstInAllotmentSearchParameters,
      searchedParams: {},
    };
  },
  mixins: [SecFilterMixin],
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      firstInTransporterList: 'indents/firstInTransporterList',
      filter: 'indents/filter',
      hasEmpty: 'indents/hasEmpty',
      isLoading: 'indents/isLoading',
      isPaginating: 'indents/isPaginating',
      otherDepots: 'app/getOtherDepots',
    }),
    selectedCategory() {
      return this.firstInAllotmentMenu.find(menu => menu.id === 'first_in_allotment');
    },
  },
  created() {
    this.setDefaults();
    this.loadFilters();
    this.$store.commit('indents/initialReset');
    this.loadSearchFromSession();
    this.search();
  },
  methods: {
    setDefaults() {
      this.defaultValues.depot = [];
      this.defaultValues.depot.push(this.depots[0] || this.otherDepots[0]);
      this.defaultValues.movement = this.indentMovementTypes[0];
    },
    constructConstantForFilter() {
      const depotList = this.constructDepotGroup(this.depots, this.otherDepots,
        this.defaultValues.depot.map(depot => depot.id));
      this.filterConstant = [
        [
          {
            type: 'MultiSelectGroup',
            category: this.filters.DEPOT,
            tlabel: 'INDENT_DEPOT',
            default: this.defaultValues.depot,
            selected: this.defaultValues.depot,
            list: depotList,
            idLabel: 'id',
            optional: false,
            allowEmpty: false,
            queryParamString: 'depot_id',
            placeholder: 'Select depots',
            selectAllOption: true,
            defaultSelectAll: true,
            search: true,
          },
        ],
        [
          {
            type: 'List',
            category: this.filters.MOVEMENT,
            tlabel: 'INDENT_MOVEMENT',
            default: this.defaultValues.movement,
            selected: this.defaultValues.movement,
            list: this.indentMovementTypes,
            idLabel: 'id',
            queryParamString: 'movement',
          },
        ],
      ];
    },
    resetApply() {
      this.$store.commit('indents/setPage', 1);
      this.resetAll();
      this.search();
    },
    search() {
      this.$store.commit('indents/setPage', 1);
      this.applyFilters();
      this.openSlideleft = false;
      this.loadData();
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    searchByParameter(params) {
      this.searchedParams = params;
      this.$store.commit('indents/setPage', 1);
      this.saveSearchToSession();
      this.loadData();
    },
    async loadData() {
      try {
        if ((this.depots.length || this.otherDepots.length)) {
          let filter = this.constructFilterPayload();
          if (filter) {
            filter = Object.assign(filter, this.filter);
            if (this.searchedParams) {
              filter = {
                ...filter,
                ...this.searchedParams,
              };
            }
            const result = await this.$store.dispatch('indents/firstInTransporterList', filter);
            if (result.error) {
              this.$errorMessage({ message: result.error });
            }
            this.loadCheck = this.hasEmpty;
          }
        } else {
          this.$errorMessage({ message: this.$getErr('FEILDS_MISSING') });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    showActions(orderNo) {
      this.selectedOrder = this.firstInTransporterList.find(order => order.order_no === orderNo);
      this.isDetailsEnabled = true;
    },
    accept() {
      this.isDetailsEnabled = false;
      this.setDefaults();
      this.loadFilters();
      this.$store.commit('indents/initialReset');
      this.search();
    },
  },
};
</script>
